import ShowMoreText from './ShowMoreText'
export default ShowMoreText
